import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePriceAndAvailability } from '@app/hooks';
import PropTypes from 'prop-types';
import CustomizeModalTable from '../CustomizeModalTable';
import * as types from '@app/store/products/constants';
import { getPartName } from '@app/utils/commonUtils';

const CustomizePackageModal = ({
  selectedQuantity,
  closeModal,
  addItemsToCart,
  loadingAddItemsToCart,
  gaListName,
  quantity
}) => {
  const dispatch = useDispatch();
  const selectedQuantityNumber = parseInt(selectedQuantity);
  const current = useSelector(s => s.products?.current);
  const productChildren = useSelector(
    s => s.products.byId?.[current]?.components
  );

  const { data: priceAndAvailability, invoke: getPriceAndAvailability } =
    usePriceAndAvailability();

  // * This gets the availability information for the package items
  useEffect(() => {
    const packageItems = productChildren.map(item => ({
      partNumber: item.partNumber,
      quantity: item.quantity * quantity,
      uniqueId: item.uniqueId
    }));
    getPriceAndAvailability({
      parts: [...packageItems]
    });
  }, [quantity]);

  useEffect(() => {
    dispatch({ type: types.SAVED_PRICE_ORIGINAL_STATE });
  }, []);

  const getItemsData = () => {
    return productChildren.map(
      ({
        name,
        quantity,
        partNumber,
        productDisplayUrl,
        productURL,
        thumbnail,
        uniqueId,
        longDescription = '',
        shortDescription = '',
        prop65 = ''
      }) => ({
        key: uniqueId ?? partNumber,
        name: getPartName(partNumber, name),
        quantity: selectedQuantityNumber * quantity,
        partNumber,
        productDisplayUrl: productDisplayUrl || productURL,
        thumbnail,
        price: priceAndAvailability?.[partNumber]?.totalPrice ?? '',
        availability:
          priceAndAvailability?.[partNumber]?.availability?.quantityAvailable ??
          '',
        availabilityMessage:
          priceAndAvailability?.[partNumber]?.availability
            ?.availabilityMessage ?? '',
        longDescription,
        shortDescription,
        loadingStatus: priceAndAvailability?.[partNumber]?.loadingStatus ?? '',
        prop65,
        unformattedTotalPrice:
          priceAndAvailability?.[partNumber]?.unformattedTotalPrice ?? ''
      })
    );
  };

  return (
    <CustomizeModalTable
      items={getItemsData()}
      closeModal={closeModal}
      addItemsToCart={addItemsToCart}
      loadingAddItemsToCart={loadingAddItemsToCart}
      gaListName={gaListName}
    />
  );
};

CustomizePackageModal.propTypes = {
  selectedQuantity: PropTypes.number,
  closeModal: PropTypes.func,
  addItemToCart: PropTypes.func,
  loadingAddItemToCart: PropTypes.bool
};

export default CustomizePackageModal;
